import { CalendarOutlined, ClearOutlined, DownloadOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Space, Typography } from "antd";
import dayjs from "dayjs";
import { type ComponentProps, useCallback } from "react";
import { OrganizationTreeSelect } from "@/modules/organization-cross-access/components/OrganizationTreeSelect";
import type { AttendanceFilterProps } from "../types";
import { RANGE_PRESETS } from "../utils/attendance.constants";

const { Text } = Typography;
type RangePickerOnChange = NonNullable<ComponentProps<typeof DatePicker.RangePicker>["onChange"]>;

export function AttendanceFilter({
	startDate,
	endDate,
	organizationId,
	onStartDateChange,
	onEndDateChange,
	onOrganizationChange,
	onReset,
	onExport,
	isExporting,
}: AttendanceFilterProps) {
	const handleOrgChange = useCallback(
		(id: string | undefined, name?: string) => {
			onOrganizationChange(id ?? null, name);
		},
		[onOrganizationChange]
	);

	const rangeValue: [dayjs.Dayjs, dayjs.Dayjs] | null =
		startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null;

	const handleRangeChange: RangePickerOnChange = (dates) => {
		if (dates?.[0] && dates?.[1]) {
			onStartDateChange(dates[0].format("YYYY-MM-DD"));
			onEndDateChange(dates[1].format("YYYY-MM-DD"));
		}
	};

	return (
		<Form layout="vertical" className="mb-4">
			<Row gutter={[16, 0]} align="bottom">
				<Col xs={24} sm={12} md={8}>
					<Form.Item
						label={
							<Space size={4}>
								<CalendarOutlined style={{ color: "#1677ff" }} />
								<span>Davomat davri</span>
								<Text type="danger" style={{ fontSize: 12 }}>
									*
								</Text>
							</Space>
						}
						style={{ marginBottom: 0 }}
					>
						<DatePicker.RangePicker
							allowClear={false}
							value={rangeValue}
							onChange={handleRangeChange}
							className="w-full"
							placeholder={["Boshlanish sanasi", "Tugash sanasi"]}
							presets={RANGE_PRESETS}
							format="DD.MM.YYYY"
							style={{ borderRadius: 8 }}
						/>
					</Form.Item>
				</Col>

				<Col xs={24} sm={12} md={8}>
					<Form.Item
						label={
							<Space size={4}>
								<TeamOutlined style={{ color: "#1677ff" }} />
								<span>Tashkilot</span>
								<Text type="danger" style={{ fontSize: 12 }}>
									*
								</Text>
							</Space>
						}
						style={{ marginBottom: 0 }}
					>
						<OrganizationTreeSelect
							value={organizationId ?? undefined}
							onChange={handleOrgChange}
						/>
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={8}>
					<Form.Item label=" " style={{ marginBottom: 0 }}>
						<Space className="w-full" style={{ justifyContent: "flex-end" }}>
							<Button
								icon={<ClearOutlined />}
								onClick={onReset}
								disabled={!(organizationId || startDate)}
								style={{ borderRadius: 8 }}
							>
								Tozalash
							</Button>
							{onExport && (
								<Button
									type="primary"
									icon={<DownloadOutlined />}
									onClick={onExport}
									loading={isExporting}
									disabled={!(organizationId && startDate && endDate)}
									style={{ borderRadius: 8 }}
								>
									Excel
								</Button>
							)}
						</Space>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
}
